var _class, _descriptor;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import Attachment from './attachment';
import { isEmpty } from '@ember/utils';
import { BLOCK_TYPES } from '@intercom/composer-core';
let AttachmentList = (_class = class AttachmentList {
  constructor(composer) {
    _defineProperty(this, "composer", void 0);
    _initializerDefineProperty(this, "attachments", _descriptor, this);
    _defineProperty(this, "isDestroying", false);
    this.composer = composer;
    let blocksDoc = composer.blocksDoc;
    this.attachments = AttachmentList.attachmentsFromBlocksDoc(blocksDoc);
  }
  get uploadedAttachments() {
    return this.attachments.filter(a => a.isUploaded);
  }
  get asBlock() {
    let uploadedAttachments = this.uploadedAttachments;
    if (isEmpty(uploadedAttachments)) {
      return;
    }
    return {
      type: BLOCK_TYPES.ATTACHMENT_LIST,
      attachments: uploadedAttachments.map(a => a.asBlockAttachment)
    };
  }
  removeAttachment(attachment) {
    this.attachments.splice(this.attachments.indexOf(attachment), 1);
    /* eslint-disable-next-line no-self-assign */
    this.attachments = this.attachments;
    this.wasUpdated();
  }
  async retryAttachment(attachment) {
    attachment.markAsPending();
    if (attachment.file) {
      let uploadResult = await this.composer.commands.doUpload(attachment.file);
      attachment.updateWithUploadResult(uploadResult);
      this.wasUpdated();
    }
  }
  addAttachment(attachment) {
    this.attachments.push(attachment);
    /* eslint-disable-next-line no-self-assign */
    this.attachments = this.attachments;
    this.wasUpdated();
  }
  wasUpdated() {
    if (!this.isDestroying) {
      this.composer.outputNewBlocksDoc();
    }
  }
  addFile(file) {
    let attachment = Attachment.fromFile(file);
    this.addAttachment(attachment);
    return attachment;
  }
  destroy() {
    this.isDestroying = true;
  }
  static attachmentsFromBlocksDoc(blocksDoc) {
    let block = blocksDoc.onlyAttachmentListBlock;
    if (block) {
      return block.attachments.map(b => Attachment.fromBlockAttachment(b));
    } else {
      return [];
    }
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "attachments", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "removeAttachment", [action], Object.getOwnPropertyDescriptor(_class.prototype, "removeAttachment"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "retryAttachment", [action], Object.getOwnPropertyDescriptor(_class.prototype, "retryAttachment"), _class.prototype), _class);
export { AttachmentList as default };